export default __webpack_public_path__ + "static/media/infoFill.1357ed62.svg";